<template>
  <div>
    <nav-header v-bind:showSearch="p_showSearch" v-bind:loginModalFlag="p_loginModalFlag" v-on:showLoginModal="p_showLoginModal" v-on:closeLoginModal="p_closeLoginModal"></nav-header>
    <nav-bread ref="child"></nav-bread>
    <div class="container">
      <template v-if="user.isChannel != 0">
<!-- 合作检验所-未登录状态 -->
        <div class="cooperation-inspection" v-if="!token">
          <span class="line"></span>
          <p class="insep">合作检验所</p>
          <ul class="coop-nav">
            <!-- <li><a href="javascript:;" class="current">全国</a></li>
            <li><a href="javascript:;">北京市</a></li>
            <li><a href="javascript:;">北京市</a></li>
            <li><a href="javascript:;">北京市</a></li>
            <li><a href="javascript:;">北京市</a></li>
            <li><a href="javascript:;">北京市</a></li>
            <li><a href="javascript:;">北京市</a></li> -->
          </ul>
          <!-- 登录 -->
          <div class="coop-login">
            <button @click="toInsep">请登录/注册查看</button>
          </div>
        </div>

        <!-- 合作检验所-登录状态 -->
        <div class="cooperation-inspection" v-else>
          <span class="line"></span>
          <p class="insep">合作检验所</p>
          <ul class="coop-nav">
            <li><a href="javascript:;" class="current">全国</a></li>
            <!-- <li><a href="javascript:;"></a>{{item.area}}</li> -->
          </ul>
          <div class="all-container">
            <el-row :gutter="10" >
              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" v-for="item in cooperationLIst" :key="item.id"><div class="grid-content bg-purple provider"  @click="toCompany(item.id)">
                <p class="insp-name">{{item.providerName}}</p>
                <p class="insp-introduce">{{item.desc}}</p>
              </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </template>

      <!-- 全国检验所 -->
      <div class="all-inspection">
        <span class="line"></span>
        <div class="tab">
          <p class="insep">全国检验所</p>
          <!-- <ul class="all-tab">
                  <li><a href="javascript:;">全部</a></li>
                  <li><a href="javascript:;">热门检验所</a></li>
                  <li><a href="javascript:;">连锁检验所</a></li>
          </ul> -->
        </div>
        <ul class="all-nav">
          <li><a href="javascript:;" class="current">全国</a></li>
          <!-- <li v-for="item in inspectionList" :key="item.id" ><a href="javascript:;"></a>{{item.area}}</li> -->
        </ul>
        <div class="all-container">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" v-for="item in inspectionList" :key="item.id"><div class="grid-content bg-purple provider" @click="toCompany(item.id)">
              <p class="insp-name">{{item.providerName}}</p>
              <p class="insp-introduce">{{item.desc}}</p>
            </div>
            </el-col>
          </el-row>

        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="totalCount"
          style="text-align:center">
        </el-pagination>
      </div>
    </div>
    <!-- <nav-footer></nav-footer> -->

  </div>

</template>

<script>
  import axios from 'axios'
  import "./../assets/css/base.css";
  import "@/assets/css/product.css";
  import "@/assets/css/index.css?version=1.0.1";
  import NavHeader from "@/components/Header.vue";
  import NavFooter from "@/components/Footer.vue";
  import NavBread from "@/components/Bread.vue";
  import {getCookie} from "@/util/util.js"
  import 'babel-polyfill'

  export default {
    name: "Inspection",
    data() {
      return {
        p_showSearch: true,
        p_loginModalFlag: false,
        hasMoreData: true,
        changes: '',
        inspectionList:[],
        cooperationLIst:[],
        providerType: this.$route.query.providerType,
        // area:  this.$route.query.area

        // 分页
        limit: 9,
        currentPage: 1,
        page: 1,
        totalCount: 0,
        totalPage: 0,
      };
    },
    components: {
      NavHeader,
      NavFooter,
      NavBread
    },
    computed: {
      token(){
        return getCookie("_token")?getCookie("_token"):""
      },
       user() {
        return this.$store.state.user;
      }
    },
    mounted(){
      this.changes = getCookie("_token")?"already":""
      // console.log(this.changes)
      this.getInspectionList( )
      this.getCooperationLIst( )
    },
    methods: {
      p_showLoginModal() {
        this.p_loginModalFlag = true;
      },

      p_closeLoginModal() {
        this.p_loginModalFlag = false;
      },
      // 分页
      handleSizeChange(val) {

        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(currentPage) {
        this.page = currentPage
        console.log(typeof currentPage, currentPage, 'currentPage')
        this.getInspectionList()
        console.log(`当前页: ${currentPage}`);
      },

      toSearch(itemName, id) {
        this.$router.push({
          path: "search",
          query: {
            id: id,
            name: itemName
          }
        });
      },

      toInsep() {
        if(getCookie("_token")){
          this.changes ="already"
        }else{
          this.p_showLoginModal()
        }
      },
      // 获取全国检验所列表
      getInspectionList () {
        //  axios.defaults.baseURL = 'http://47.103.75.157:8090'
        axios.get("/jys/provider",{
          params: {
            providerType: 0,
            limit: this.limit,
            page: this.page,
            // area
          }
        }).then((res) => {
          // axios.defaults.baseURL = process.env.API_ROOT
          console.log('检验所res', res)
          this.inspectionList = res.data.page.list;
          console.log('this.inspectionList', this.inspectionList)
          // let insDetailLengthList = []
          // for (var i = 0; i <  this.inspectionList.length; i++) {
          //   let len = this.inspectionList[i].orderDetailList.length
          //   console.log(len, 'this.inspectionList')
          //   detailLengthList.push(len)
          // }
          this.totalPage = res.data.page.totalPage
          this.totalCount = res.data.page.totalCount
          console.log('this.totalPage', this.totalPage)
          console.log('this.totalCount', this.totalCount)
        })
      },
      // 跳转到相关检验所
      toCompany(id) {
        this.$router.push({path: "/company/index", query: {id: id}})
      },
      // 获取合作检验所列表
      getCooperationLIst() {
        axios.get("/jys/provider/me",{
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          },
          params: {
            providerType:0,
            // area
          }
        }).then((res) => {
          // console.log(res)
          this.cooperationLIst = res.data.page.list;
          // console.log(res.data.page.list)
        })
      }
    },

    watch: {
      'token': function(newVal){
        this.changes = newVal?"already":""
      }
    }
  };
</script>

<style scoped >
  .container {
    width: 75%;
    margin-top: 15px;
  }
  .cooperation-inspection{
    overflow: hidden;
  }
  .insep {
    width: 100%;
    height: 37px;
    line-height: 32px;
    border-bottom: 2px solid #00C4AA;
    font-size: 17px;
    box-sizing: border-box;
    font-weight: 700;
  }
  .line{
    width: 88px;
    height: 2px;
    border-top:2px solid #00C4AA;
    display: inline-block;
  }
  .coop-nav,.all-nav {
    padding: 10px 15px;
    display: inline-block;
    width: 100%;
  }
  .coop-nav li,.all-nav li {
    float: left;
    width: 10rem /* 160/16 */;
    height: 14px；
  }
  .coop-nav li a, .all-nav li a {
    font-size: 16px;
  }
  .current {
    color: #00C4AA;
  }
  .coop-login{
    width: 99%;
    height: 103px;
    margin: 0 auto;
    box-shadow: 0 0 5px #ccc;
    position: relative;
    margin-bottom: 10px;
  }

  .coop-login button {
    width: 170px;
    height: 32px;
    background-color: #00C4AA;
    color: #fff;
    line-height: 32px;
    font-size: 16px;
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
  }
  .all-inspection {
    overflow: hidden;
    position: relative;
  }
  .all-tab {
    overflow: auto;
    height:20px;
    width: 100%;
    position: absolute;
    top: 27px;
    left: 90px;
  }
  .all-tab li {
    padding: 0 .625rem /* 10/16 */;
    float: left;
    height: 14px;
    font-size: 16px;
    text-align: center;
  }
  .tab {
    width: 100%;
  }
  .grid-content {
    height: 103px;
    margin-bottom: 30px;
    margin-right: 20px;
    margin-left: 10px;
    border-radius: 0;
    box-shadow: 0 0 5px #ddd;
    background-color: #fff;
    text-align: left;
    padding: 10px 20px;
    box-sizing: border-box;
    overflow: hidden;
  }
  .grid-content:hover {
    box-shadow: 0 0 10px #00C4AA;
    cursor: pointer;
  }
  .insp-name, .insp-introduce {
    max-height: 38.5px;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
    display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient:vertical;
  }
  .insp-introduce {
    color: #888888;
    font-weight: 400;
    max-height: 37px;
    font-size: 15px;
  }
/*
    .insp-name, .insp-introduce{position: relative; line-height: 20px; max-height: 40px;overflow: hidden;}
     .insp-introduce::after{content: "..."; position: absolute; bottom: 0; right: 0; padding-left: 40px;
    } */
</style>



// WEBPACK FOOTER //
// src/pages/Inspection.vue